var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'fgAutocomplete';

var	DEFAULTS = {
	url: '/qf/cs/ramjet/productsAutocomplete',
	destinationInputSelector: '',
	initValue: []
};

/**
 *
 * @param selector
 * @param options
 * @constructor
 */
var FgAutocomplete = function (selector, options) {
	this.$input = this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

/**
 *
 * @private
 */
FgAutocomplete.prototype.initialise_ = function() {

	this.$destinationInput = $(this.options.destinationInputSelector);

	this.keyUpTimer = null;
	this.$renderedResult = null;
	this.valBeforeKeyPress = '';
	this.selectedItem = -1;

	this.$input.attr('autocomplete', 'off');


	this.bindEvents_();
	if (this.options.initValue && this.options.initValue.length > 0) {
		this.renderInitialValue_();
	}

};

FgAutocomplete.prototype.bindEvents_ = function() {
	var self_ = this;

	this.bindTextEntering_();
	this.bindFulltextEvents_();
};

/**
 *
 * @private
 */
FgAutocomplete.prototype.bindTextEntering_ = function() {

	var self_ = this;

	this.$input.on('keyup.ta_', function(e) {
		clearTimeout(self_.keyUpTimer);
		var val = $(e.currentTarget).val();

		if (self_.valBeforeKeyPress == val) return false;

		if (val.length > 1) {
			self_.keyUpTimer = setTimeout(function() {
				self_.performSearch_(val);
			}, 250);

		} else {
			self_.removeAutocompleteResult_();
		}
	});

};

FgAutocomplete.prototype.bindFulltextEvents_ = function() {
	var self_ = this;

	this.$input.off('keydown.ta_').on('keydown.ta_', function(e) {
		//enter
		if (e.keyCode == 13) {
			e.preventDefault();
			self_.removeAutocompleteResult_();
		}
	});
};

FgAutocomplete.prototype.bindAutocompleteResultEvents_ = function() {
	var self_ = this;
	this.$input.off('keydown.ta_').on('keydown.ta_', function(e) {

		self_.valBeforeKeyPress = self_.$input.val();

		if ((self_.$renderedResult instanceof $)) {
			var liCnt = $('li', self_.$renderedResult).size();
			// down
			if (e.keyCode == 40) {
				e.preventDefault();
				if (self_.selectedItem < liCnt-1) {
					self_.selectedItem++;
				}
			}

			// up
			if (e.keyCode == 38) {
				e.preventDefault();
				if (self_.selectedItem > 0) {
					self_.selectedItem--;
				}
			}

			//enter
			if (e.keyCode == 13) {

				if (self_.selectedItem > -1 && self_.selectedItem < $('li', self_.$renderedResult).size()) {
					e.preventDefault();
					// TODO action
					self_.performSelectAction_($('li:eq('+self_.selectedItem+') > a', self_.$renderedResult));
				} else {
					e.preventDefault();
					self_.removeAutocompleteResult_();
				}
			}

			//escape
			if (e.keyCode == 27) {
				e.preventDefault();
				self_.$destinationInput.val('');
				self_.$input.val('');
				self_.removeAutocompleteResult_();
			}



			$('li', self_.$renderedResult).removeClass('active');
			if (self_.selectedItem > -1) {
				$('li:eq('+self_.selectedItem+')', self_.$renderedResult).addClass('active');
			}
		}
	});

	$(this.$renderedResult).on('mouseover', 'li', function(e) {
		$('li', self_.$renderedResult).removeClass('active');
		$(e.currentTarget).addClass('active');
		self_.selectedItem = $('li', self_.$renderedResult).index(e.currentTarget);
	});

	$(this.$renderedResult).on('click', 'li > a', function(e) {
		self_.performSelectAction_($(e.currentTarget));
	});

	this.$input.off('blur.ta_').on('blur.ta_', function(e) {
		e.preventDefault();
		if (!$(e.currentTarget).val() || $(e.currentTarget).val() == '') {
			self_.$destinationInput.val('');
		}
		setTimeout(function() {
			self_.removeAutocompleteResult_();
		}, 100);

	});
};

FgAutocomplete.prototype.performSearch_ = function(query) {
	var self_ =  this;
	this.$t.addClass('loading');

	$.post(this.options.url, {
			query: query
		},
		function(data) {
			if (data && data.results && $.isArray(data.results) && data.results.length > 0) {
				var dataToSend = [];
				for (var i = 0; i < data.results.length; i++) {
					dataToSend.push(data.results[i]);
				}
				if (dataToSend.length > 0) {
					self_.renderResults_(dataToSend);
				} else {
					self_.removeAutocompleteResult_();
				}
			} else {
				self_.removeAutocompleteResult_();
			}
		}, "json");
};

FgAutocomplete.prototype.renderResults_ = function(data) {
	this.selectedItem = -1;
	var result = this.formatResults_(data);

	this.removeAutocompleteResult_();

	if (result === "") {
		return false;
	}
	this.$t.removeClass('loading');
	this.$renderedResult = $(result).insertAfter(this.$t);

	this.bindAutocompleteResultEvents_();
};

FgAutocomplete.prototype.formatResults_ = function(data) {
	var result = '<div class="fg-autocomplete-result-wrapper"><ul class="fg-autocomplete-result products-autocomplete">';
	for (var i = 0; i < data.length; i++) {
		result += '<li>';
		result += '	<a class="noPartialUpdate" href="javascript:void(0)" data-title="'+data[i].title+'" data-subtitle="'+data[i].fullTitle+'" data-product-id="'+data[i].id+'">';
		if (data[i].thumb) {
			result += '<img src='+data[i].thumb+' alt="" width="80" height="80">';
		}
		result += data[i].title;
		if (data[i].fullTitle) {
			result += '<em>' + data[i].fullTitle + '</em>';
		}
		result += '	</a>';

		result += '</li>'
	}
	result += '</ul></div>';
	return result;
};

FgAutocomplete.prototype.removeAutocompleteResult_ = function() {
	if (this.$renderedResult &&  this.$renderedResult instanceof $) {
		this.$renderedResult.remove();
	}
	this.selectedItem = -1;
};

FgAutocomplete.prototype.performSelectAction_ = function($element) {
	var id = $element.data('productId');
	var title = $element.data('title');
	var subtitle = $element.data('subtitle');

	if (id) {
		this.$destinationInput.val(id);
		this.renderValue_(title, subtitle);
	}
};

FgAutocomplete.prototype.renderInitialValue_ = function() {
	this.renderValue_(this.options.initValue['item-'+this.$destinationInput.val()].title, this.options.initValue['item-'+this.$destinationInput.val()].fullTitle);
};

FgAutocomplete.prototype.renderValue_ = function(title, subtitle) {
	this.$t.val(title + ' (' + subtitle + ')');
};

/**
 * decide, which methods will be "public"
 */
var API = {
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new FgAutocomplete(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.fg-autocomplete.js